import { Share, ShareOptions } from '@capacitor/share'
export type { ShareOptions } from '@capacitor/share'

/**
 * @description
 * WebShareAPIはブラウザによって非対応（PC Chrome等）なのでpolyfillを入れて対応
 * https://wp-kyoto.net/use-webshare-api-with-polyfil-and-capacitor/
 */
import 'share-api-polyfill'

export const share = (opt: ShareOptions) => {
  return Share.share(opt).catch(e => {
    /**
     * @description
     * ネイティブでのシェア取り消しなど、ユーザー動作起因のキャンセルの場合エラーは投げない
     */
    if (
      e.message === 'Share canceled' ||
      e.message === 'Abort due to cancellation of share.'
    )
      return

    throw e
  })
}
